import { render, staticRenderFns } from "./Projet.vue?vue&type=template&id=2af78988&"
import script from "./Projet.vue?vue&type=script&lang=js&"
export * from "./Projet.vue?vue&type=script&lang=js&"
import style0 from "./Projet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports